import { isWlDemoBlobRef } from "./demoTrackBlobStore";

export function pickArtworkSrc(artwork) {
  if (artwork == null || artwork === "") {
    return null;
  }
  if (typeof artwork === "string") {
    const trimmed = artwork.trim();
    return trimmed || null;
  }
  if (typeof artwork === "object") {
    if (typeof artwork.default === "string" && artwork.default.trim()) {
      return artwork.default.trim();
    }
    const nested =
      artwork.thumb_small || artwork.thumb_medium || artwork.full_size || artwork.thumb_large || null;
    return nested ? String(nested).trim() || null : null;
  }
  return null;
}

export function isValidArtworkRef(value) {
  const raw = pickArtworkSrc(value);
  if (!raw) {
    return false;
  }
  if (isWlDemoBlobRef(raw)) {
    return true;
  }
  return /^(https?:\/\/|blob:|data:|\/)/i.test(raw);
}

export function normalizeDemoArtworkField(artwork) {
  const raw = pickArtworkSrc(artwork);
  if (!raw || !isValidArtworkRef(raw)) {
    return null;
  }
  return { thumb_small: raw, thumb_medium: raw };
}
